import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.page.html',
  styleUrl: './sign-in.page.scss',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule,
    PasswordModule,
    ButtonModule,
  ],
  providers: [AuthService, TranslateService],
})
export class SignInComponent implements OnInit {
  loginForm: FormGroup;

  isLoading = false;

  authError: string | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.pattern('^.*[a-zA-Z0-9].{3,}')]],
    });
  }

  ngOnInit() {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.authError = null;

      const { email, password } = this.loginForm.value;

      this.authService.login(email, password).subscribe({
        next: (response) => {
          if (response.status === 'Success') {
            this.isLoading = false;
            this.router.navigate(['/otpVerification'], {
              state: { email },
            });
          } else {
            this.isLoading = false;
            this.authError = this.translate.instant('SIGN_IN.ERROR_MESSAGE.INVALID_PASSWORD_EMAIL');
            setTimeout(() => {
              this.authError = null;
            }, 4000);
          }
        },
        error: () => {
          this.isLoading = false;
          this.loginForm.reset();
          this.authError = this.translate.instant('SIGN_IN.ERROR_MESSAGE.ERROR_OCCURRED_TRY_AGAIN');
          setTimeout(() => {
            this.authError = null;
          }, 4000);
        },
      });
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}
